<template>
    <flex-container
        :padding="Size.xl"
        :gap="null"
        class="rules-view"
    >
        <flex-container :gap="null">
            <flex-container
                v-if="false"
                :size="5"
                justify-content="space-between"
                class="rules-view__title--left"
            >
                <text-decorator :size="FontSize.lg">
                    Analyse van jouw organisatie
                </text-decorator>

                <button-text
                    v-if="hasAISources"
                    @click="router.push({ name: 'settings-virtual-colleague-ai-sources' })"
                >
                    <svg-icon :icon="CogIcon" />
                    <span>URL bronnen beheren</span>
                </button-text>
            </flex-container>
            <!-- <flex-container :size="5" class="rules-view__title--right"> -->
            <flex-container :size="5" class="rules-view__title">
                <text-decorator :size="FontSize.lg">
                    Instructie
                </text-decorator>
            </flex-container>
        </flex-container>

        <flex-container
            v-if="false"
            :size="5"
            :gap="Size.xs"
            class="rules-view-splitter"
        >
            <flex-container class="rules-view__list">
                <flex-container
                    justify-content="center"
                    :gap="Size.sm"
                >
                    <card-expandable with-content with-indicator>
                        Tone of voice

                        <template #content>
                            <text-description :color="Color.gray500">
                                Elementen:<br>
                                <ol>
                                    <li>
                                        The standard Lorem Ipsum passage, used since the 1500s<br>
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                                    </li>
                                    <li>
                                        Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC<br>
                                        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"
                                    </li>
                                    <li>
                                        1914 translation by H. Rackham<br>
                                        "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?"
                                    </li>
                                </ol>
                            </text-description>
                            <horizontal-line />
                            <flex-container justify-content="flex-end">
                                <button-text :color="Color.yellow600">
                                    <svg-icon
                                        :icon="SparklesOutlinedIcon"
                                        :size="IconSize.sm"
                                        is-custom-icon
                                    />
                                    <span>Opnieuw analyseren</span>
                                </button-text>
                                <button-text>
                                    <svg-icon :icon="EditIcon" :size="IconSize.sm" />
                                    <span>Bewerken</span>
                                </button-text>
                            </flex-container>
                        </template>
                    </card-expandable>
                    <card-expandable with-content with-indicator>
                        Missie

                        <template #content>
                            <text-description :color="Color.gray500">
                                Elementen:<br>
                                <ol>
                                    <li>
                                        The standard Lorem Ipsum passage, used since the 1500s<br>
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                                    </li>
                                    <li>
                                        Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC<br>
                                        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"
                                    </li>
                                    <li>
                                        1914 translation by H. Rackham<br>
                                        "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?"
                                    </li>
                                </ol>
                            </text-description>
                            <horizontal-line />
                            <flex-container justify-content="flex-end">
                                <button-text :color="Color.yellow600">
                                    <svg-icon
                                        :icon="SparklesOutlinedIcon"
                                        :size="IconSize.sm"
                                        is-custom-icon
                                    />
                                    <span>Opnieuw analyseren</span>
                                </button-text>
                                <button-text>
                                    <svg-icon :icon="EditIcon" :size="IconSize.sm" />
                                    <span>Bewerken</span>
                                </button-text>
                            </flex-container>
                        </template>
                    </card-expandable>
                    <card-expandable with-content with-indicator>
                        Samenwerkende partijen

                        <template #content>
                            <text-description :color="Color.gray500">
                                Elementen:<br>
                                <ol>
                                    <li>
                                        The standard Lorem Ipsum passage, used since the 1500s<br>
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                                    </li>
                                    <li>
                                        Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC<br>
                                        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"
                                    </li>
                                    <li>
                                        1914 translation by H. Rackham<br>
                                        "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?"
                                    </li>
                                </ol>
                            </text-description>
                            <horizontal-line />
                            <flex-container justify-content="flex-end">
                                <button-text :color="Color.yellow600">
                                    <svg-icon
                                        :icon="SparklesOutlinedIcon"
                                        :size="IconSize.sm"
                                        is-custom-icon
                                    />
                                    <span>Opnieuw analyseren</span>
                                </button-text>
                                <button-text>
                                    <svg-icon :icon="EditIcon" :size="IconSize.sm" />
                                    <span>Bewerken</span>
                                </button-text>
                            </flex-container>
                        </template>
                    </card-expandable>
                </flex-container>
            </flex-container>
        </flex-container>

        <flex-container
            :size="5"
            :gap="Size.xs"
        >
            <!-- TODO: Skeleton -->
            <rule-list />
        </flex-container>
    </flex-container>
    <router-view />
</template>
<script setup lang="ts">
    import { CardExpandable, Color, FontSize, IconSize, Size } from '@keyvue/one-ui';
    import EditIcon from '@keyvue/one-material-icons/icons/edit.svg?component';
    import SparklesOutlinedIcon from '@assets/icons/SparklesOutlined.svg?component';
    import CogIcon from '@keyvue/one-material-icons/icons/settings.svg?component';
    import { useRouter } from 'vue-router';
    import RuleList from '@components/List/AI/RuleList.vue';

    const hasAISources = true;

    const router = useRouter();
</script>

<style lang="scss" scoped>
.rules-view {
    padding-top: 0 !important;

    &__save {
        padding-top: 60px;
    }

    &__title{
        &--left {
            padding-right: size(xl);
        }

        &--right {
            padding-left: size(xl);
        }
    }

    &__list {
        padding-top: size(md);
    }
}

.rules-view-splitter {
    position: relative;

    padding-right: size(xl);

    & + div {
        padding-left: size(xl);
    }

    &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        height: calc(100% + size(md));
        width: 1px;
        background-color: color(gray-200);
    }
}
</style>
